export default __webpack_public_path__ + "static/media/promo-issue-no-1_03.c051039a.jpg";